
import { HttpParams } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { Params, Router } from '@angular/router';
import { FeaturesBaseComponent } from 'src/app/features-common/components/features-base.component';
import { CurrencyPipe, formatDate } from '@angular/common';
import { PromotionsService } from '../promotions.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-retailer-banner',
  templateUrl: './retailer-banner.component.html',
  styleUrls: ['./retailer-banner.component.scss'],
  providers: [CurrencyPipe]
})
export class RetailerBannerComponent extends FeaturesBaseComponent implements OnInit {

  columnDefs
  rowData: any = [];
  rowSelection: string;
  private gridApi;
  private gridColumnApi;
  searchValue;
  showUpdateRetailer: boolean;
  selectedRows: any;
  griddata: any = [];
  retailerId: any;
  selectedRetailer:any=[];
  prevSelectedRetailer: any;
  defaultColDef: { flex: number; minWidth: number; resizable: boolean; };
  constructor(private router: Router,private promotionService: PromotionsService, private currencyPipe: CurrencyPipe) {
    super();
    this.promotionService.getretailerGrid().subscribe(res => {
      let resData: any = res;
      if (resData.httpcode == 200) {
        resData = resData.data;
        var griddata = new Array();
        resData.forEach(element => {
          //;
    
          griddata.push({
            retailerId: element.retailerDetails.retailerId,
            retailerAccountNum: element.retailerAccountNum,
            retailerType: element.retailerDetails.retailerType,
            retailerStatus: element.retailerDetails.retailerStatus,
            businessName: element.retailerDetails.businessName,
            dbaName: element.retailerDetails.dbaName,
            city: element.retailerDetails.city,
            salesRepName: element.salesRepName,
            state: element.retailerDetails.state,
            showBanner:element.retailerDetails.showBanner
          })
        });
        this.setGrid(griddata);
      }
    })

  }

  ngOnInit(): void {
  }

  setGrid(data: any) {
    const self=this;
    this.columnDefs = [
      { field: 'retailerId', headerName: 'retailerId', width: 0, hide: true, sort: "desc" },
      { field: 'null', headerName: '', width: 100, headerCheckboxSelection: true,
      headerCheckboxSelectionFilteredOnly: true,
      checkboxSelection: true ,cellRenderer: function (params) {
        if (params.data.showBanner == "Yes") {
         self.gridApi.forEachNode(node => {
        if (node.data.showBanner == "Yes") {
         node.setSelected(true);
      }
      })
      }}},
      { field: 'retailerAccountNum', headerName: 'Account #', width: 150, },
      { field: 'showBanner', headerName: 'Display Banner', width: 180 },
      { field: 'retailerType', headerName: 'Account Type', width: 180 },
      { field: 'retailerStatus', headerName: 'Status', width: 160 },
      { field: 'salesRepName', headerName: 'Sales Rep/Dist', width: 200 },
      { field: 'city', headerName: 'City', width: 160 },
      { field: 'state', headerName: 'State', width: 130 },
      { field: 'businessName', headerName: 'Retailer Name', width: 200 },
      { field: 'dbaName', headerName: 'DBA Name', width: 180 }
      

    ]
    this.rowData = data;
    this.rowSelection = 'multiple';
  }
  reloadComponent() {
    let currentUrl = this.router.url;
        this.router.routeReuseStrategy.shouldReuseRoute = () => false;
        this.router.onSameUrlNavigation = 'reload';
        this.router.navigate([currentUrl]);
    }

  onSelectionChanged(e) {
    this.selectedRows = this.gridApi.getSelectedRows();
    if (this.selectedRows  && this.selectedRows.length > 0) {
      this.selectedRetailer= this.selectedRows.map(d => d.retailerId);
        this.showUpdateRetailer = true;
        return
    }else{
      this.selectedRetailer=[];
    }
    this.showUpdateRetailer = false;
  }
  mapRetailerConfig(){
    this.promotionService.mapRetailers(this.selectedRetailer).subscribe(res => {
      if (res && res) {
        if(res.httpcode == 200  || res.responseStatus == 'Success'){
          this.router.navigate(['features/promotions/retailer-banner'])
          this.toastrService.success('Retailers mapped successfully', 'Success', {
            timeOut: 3000,
          }); 
          this.reloadComponent()       
      } else if (res.errorCodes && res.errorCodes[0] == "TILA_113") { 
          Swal.fire(
            {
              title: res.responseStatus,
              text: res.userMessage,
              icon: 'error',
              timer: 2000
            }
          )
          this.router.navigate(['features/promotions/retailer-banner'])
        } else {
          Swal.fire(
            {
              title: res.responseStatus,
              text: res.userMessage,
              icon: 'error',
              timer: 2000
            }
          )
          this.router.navigate(['features/promotions/retailer-banner'])
        }
      }
    }
  );
  }



  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  }




  quickSearch() {
    this.gridApi.setQuickFilter(this.searchValue);
  }

}
